import { render, staticRenderFns } from "./ClassroomStudent.vue?vue&type=template&id=074825b3&scoped=true"
import script from "./ClassroomStudent.vue?vue&type=script&lang=js"
export * from "./ClassroomStudent.vue?vue&type=script&lang=js"
import style0 from "./ClassroomStudent.vue?vue&type=style&index=0&id=074825b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074825b3",
  null
  
)

export default component.exports